import { AlertTriangle } from 'components/icons'

/**
 * Shown at the top of a drawer whose entity has click detection off (DEV-2422 §2.3).
 *
 * Informational only — it does not disable anything below it. On the ad-account drawer
 * it sits below the tab row so it is visible on BOTH tabs, and it is the only place a
 * reader can learn why a campaign has no toggle at all: an ad account that is off stops
 * every campaign under it, and the table then renders no campaign toggle to explain it.
 *
 * Deliberately NOT the DS `Banner`, for the same reason the card's own monitoring-off
 * block is not: `Banner` is page chrome at `rounded-2xl p-6`, roughly twice the padding
 * of the drawer sections it would sit among.
 */
export const ClickDetectionBanner = ({
	scope
}: {
	scope: 'ad account' | 'campaign'
}) => (
	<div className="flex items-start gap-2 rounded-lg border border-[rgb(var(--cg-warning-dark))] bg-[rgb(var(--cg-warning-50))] p-3">
		<span className="mt-px shrink-0 text-[rgb(var(--cg-warning-dark))] [&>svg]:h-4 [&>svg]:w-4">
			<AlertTriangle />
		</span>
		<p className="text-[12px] leading-4 text-[rgb(var(--cg-text-secondary))]">
			Click detection is disabled for this {scope}. New clicks won&apos;t be
			flagged or blocked, and its spend won&apos;t count toward your monthly
			usage limit.
		</p>
	</div>
)
